import { cn } from '@/lib/utils';
import type { Emblem } from '../cosmetics';

interface EmblemGlyphProps {
  emblem: Emblem;
  size?: number;
  /** Soft glow halo behind the glyph (OG `--glow-color` drop-shadow). */
  glow?: boolean;
  className?: string;
}

/**
 * Renders an emblem's inline SVG tinted to its glow color. The catalog SVGs use
 * `currentColor`, so color + drop-shadow are driven by the glow value.
 */
export function EmblemGlyph({ emblem, size = 28, glow = true, className }: EmblemGlyphProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center [&_svg]:h-full [&_svg]:w-full',
        className,
      )}
      style={{
        width: size,
        height: size,
        color: emblem.glow,
        filter: glow ? `drop-shadow(0 0 8px ${emblem.glow})` : undefined,
      }}
      aria-hidden
      dangerouslySetInnerHTML={{ __html: emblem.svg }}
    />
  );
}
